import { Icon } from "@/components/BaseComponents/Icon";

export const RightIcon = (props) => (
	<Icon fill="none" {...props}>
		<path
			d="M8.76 6.83a1 1 0 0 1 1.33-.14l.08.07 5 4.5a1 1 0 0 1 0 1.48l-5 4.5a1 1 0 1 1-1.34-1.48L13 12 8.83 8.24l-.07-.07a1 1 0 0 1 0-1.34Z"
			fill="currentColor"
		/>
	</Icon>
);
